<template lang="pug">
.the-header.box-shadow--large(:class="showDarkHeader ? 'brand-dark-blue theme--dark' : 'white'")
  k-container.py-0.my-0
    .d-flex.align-center
      // Kintell logo
      .d-flex.align-center
        nuxt-link(to="/" data-test-id="logo-link").unstyled--link.d-flex.align-center
          img(:src="showDarkHeader ? lightLogoUrl : logoUrl" alt="Kintell" width="auto" height="42").mr-7
        nuxt-link(v-if="isOnArticles" to="/articles").unstyled--link.paragraph--book.font-family--secondary.font-weight-bold Articles

      v-spacer
      .the-header__mobile-navigation
        div(v-if="$vuetify.breakpoint.smAndDown").hidden-md-and-up.d-flex.align-center
          nuxt-link(v-if="userIsAuthenticated" :to="pages.dashboard").unstyled--link.d-flex.align-items-center.mr-7
            .d-flex
              v-badge(color="brand-pink" right top overlap :value="alertCount")
                template(v-slot:badge) {{ alertCount }}
                k-user-avatar(
                  :size="36"
                  :src="authenticatedUser.avatarUrl"
                  :alt="nameTitle"
                )
          the-navigation-drawer(:pages="pages")
      div(v-if="$vuetify.breakpoint.mdAndUp").hidden-sm-and-down
        .d-flex.align-center.justify-end.the-header__links
          template(v-if="!userIsAuthenticated")
            //- Guest header links
            nuxt-link(:to="pages.search").font-weight-semibold.unstyled--link.paragraph--semi-medium.brand-dark-blue--text.the-header__link {{ $t('app.pages.search.title') }}
            nuxt-link(:to="pages.becomeAnAdvisor").font-weight-semibold.unstyled--link.paragraph--semi-medium.brand-dark-blue--text.the-header__link {{ $t('app.pages.becomeAnAdvisor.title') }}
            nuxt-link(:to="pages.pricing").font-weight-semibold.unstyled--link.paragraph--semi-medium.brand-dark-blue--text.the-header__link {{ $t('app.pages.pricing.title') }}
            nuxt-link(:to="pages.faqs").font-weight-semibold.unstyled--link.paragraph--semi-medium.brand-dark-blue--text.the-header__link {{ $t('app.pages.faqs.title') }}
            k-button-outline(:color="showDarkHeader ? 'white' : 'brand-dark-blue'" :to="pages.joinNow" x-small).ma-0 {{ $t('app.pages.joinNow.title') }}
            k-button(:to="pages.login" data-test-id="sign-in-button" x-small) {{ $t('app.pages.login.title') }}
          template(v-else)
            nuxt-link(:to="pages.search").font-weight-semibold.unstyled--link.paragraph--semi-medium.brand-dark-blue--text.the-header__link {{ $t('app.pages.search.title') }}
            nuxt-link(:to="pages.becomeAdvisor" v-if="authenticatedUserIsLearner").font-weight-semibold.unstyled--link.paragraph--semi-medium.brand-dark-blue--text.the-header__link {{ $t('app.pages.becomeAnAdvisor.title') }}
            nuxt-link(:to="pages.pricing").font-weight-semibold.unstyled--link.paragraph--semi-medium.brand-dark-blue--text.the-header__link {{ $t('app.pages.pricing.title') }}
            nuxt-link(:to="pages.faqs").font-weight-semibold.unstyled--link.paragraph--semi-medium.brand-dark-blue--text.the-header__link {{ $t('app.pages.faqs.title') }}
            // Users profile image link to my dashboard
            nuxt-link(:to="pages.dashboard").unstyled--link.d-flex.align-items-center
              .d-flex
                v-badge(color="brand-pink" right top overlap :value="alertCount")
                  template(v-slot:badge) {{ alertCount }}
                  k-user-avatar(
                    :size="36"
                    :src="authenticatedUser.avatarUrl"
                    :alt="nameTitle"
                  )
                .the-header__dashboard-link
                  p(:class="showDarkHeader ? 'white--text' : 'brand-dark-blue--text'").pl-5.small-caps--small.mb-0 {{ nameTitle }}
                  p.pl-5.brand-light-pink--text.font-weight-bold.paragraph.mb-0 My Dashboard
</template>


<script>
import { UsesAuthenticatedUser } from '@/mixins'
import { get } from 'vuex-pathify'
import TheNavigationDrawer from './TheNavigationDrawer'

export default {
  components: { TheNavigationDrawer },
  mixins: [ UsesAuthenticatedUser ],
  data () {
    return {
      pages: {
        // unauthenticated
        becomeAnAdvisor: '/become-an-advisor',
        // authenticated
        search: '/search',
        getInTouch: '/get-in-touch',
        faqs: '/faq',
        browseByCategory: '/browse-by-category',
        dashboard: '/my-kintell/dashboard',
        bookings: '/my-kintell/bookings',
        becomeAdvisor: '/my-kintell/kintell-cards',
        myKintellCards: '/my-kintell/kintell-cards',
        myRewards: '/my-kintell/my-rewards',
        calendar: '/my-kintell/my-calendar',
        credits: '/my-kintell/credits',
        personalDetails: '/my-kintell/my-details',
        favourites: '/my-kintell/favourites',
        pricing: '/pricing',
        login: '/sign-in',
        signOut: '/sign-out',
        joinNow: '/join-now',
        articles: '/articles',
      },
      logoUrl: require('~images/kintell-logo.svg'),
      lightLogoUrl: require('~images/kintell-logo-light.svg'),
    }
  },
  computed: {
    ...get({
      awaitingBookingSession: 'myKintell/awaitingBookingSession',
    }),
    isOnArticles () {
      return this.$route.path.includes('/articles')
    },
    showDarkHeader () {
      return this.isOnArticles
    },
    alertCount () {
      return this.authenticatedUser.stats.alerts + (this.authenticatedUser.stats.bookingActive ? 1 : 0)
    },
    nameTitle () {
      if (!this.authenticatedUser || !this.authenticatedUser.firstName) {
        return ''
      }
      if (this.authenticatedUser.fullName.length <= 15) {
        return this.authenticatedUser.fullName
      }
      return this.authenticatedUser.firstName.length > 15 ? 'My Kintell' : this.authenticatedUser.firstName
    },
  },
}
</script>


<style lang="scss" scoped>
.the-header {

  padding: 29px 0 !important;
  @include sm-and-down {
    padding: 16px 0 !important;
  }

  &__release {
    @include lg-and-down() {
      ::v-deep .v-chip__content {
        padding: 0 10px !important;
      }
    }
  }

  &__links {
    .the-header__link {
      margin-right: 36px !important;
      transition: color .2s;

      &.nuxt-link-exact-active {
        color: var(--v-grey-0-base) !important;
      }
      @include md-and-down() {
        margin-right: 24px !important;
      }
    }

  }

  &__checkbox {
    visibility: hidden;
  }

  &__mobile-navigation {
    align-items: center;
    display: flex;
  }
}

.theme--dark {
  ::v-deep {
    .k-icon-hamburger__burger {
      span {
        background: white !important;
      }
    }

    a {
      color: white !important;
    }
  }
}
</style>
